import React, { memo } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// import { app } from 'components/app';
import { showComponentOnSelectedRoute } from 'components/app/helpers';
import MaintenanceBanner from 'components/maintenance/notification';
// import Trollbox from 'components/trollbox';
import {
  // HIDE_TROLLBOX_PATH,
  // isTrollboxEnabled,
  PLATFORM_STATUS_URL,
  SHOW_MAINTENANCE_NOTIF,
} from 'constants/constants';
import { MIXPANEL_EVENT_NAMES, MIXPANEL_SOURCES } from 'constants/mixpanelEventNames';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { formatDuration } from 'helpers/utils';
import { isUserPermissionForLiveChatSelector } from 'selectors/otherSelectors';
import { LearnMoreIcon, LiveChatIcon, UserOnlineIcon } from 'styles/assets/icons';

import OfflineIcon from './OfflineIcon';
import styles from './styles.module.scss';

// import { userPreferencesSelector } from 'selectors';
// import MaintenanceTimer from './MaintenanceTimer';

const DesktopView = ({ isOffline, isOnline, isloggedin, disconnectTime }) => {
  // const user = useSelector(state => state.user);
  const location = useSelector(state => state.router.location);
  const { t } = useTranslation(['common']);
  const currentTime = new Date().getTime();
  const isLiveChatEnabled = useSelector(isUserPermissionForLiveChatSelector);

  // const userPrefrences = useSelector(state => userPreferencesSelector(state));
  // const showTrollBox =
  //   isTrollboxEnabled && !showComponentOnSelectedRoute(HIDE_TROLLBOX_PATH)(location);

  const lastUpdated = disconnectTime
    ? formatDuration(Math.floor((currentTime - disconnectTime) / 1000))
    : 0;

  const showMaintenance = showComponentOnSelectedRoute(SHOW_MAINTENANCE_NOTIF)(location);

  const handleLiveChatClick = () => {
    window.$chatwoot.toggle();
    trackMixpanelEvent(MIXPANEL_EVENT_NAMES.LIVE_CHAT_CLICKED, {
      source: MIXPANEL_SOURCES.TRADING_APP,
    });
  };

  return (
    (<div className={cx(styles.container)} data-palette="DesktopView">
      {isOnline && (
        <>
          <div
            className="flex-set align-items-center connection-status"
            data-palette="DesktopView">
            <UserOnlineIcon />
            <a
              data-testid="connected-link"
              className={styles.statusLink}
              href={PLATFORM_STATUS_URL}
              target="_blank"
              rel="noreferrer noopener"
            >
              {t('common:connected')}
              <LearnMoreIcon className={styles.learnMoreIcon} />
            </a>
            {/* <MaintenanceTimer isLoggedIn={isloggedin} /> */}
          </div>
          {showMaintenance ? (
            <div className={styles['maintenance-notification']} data-palette="DesktopView">
              <MaintenanceBanner
                className="maintenance-notification"
                isLoggedIn={isloggedin}
                showWhatToExpect
              />
            </div>
          ) : null}
          {/* {showTrollBox && (
            <Trollbox isloggedin={isloggedin} userName={user.userName} app={app} />
          )} */}
        </>
      )}
      {isOffline && (
        <div className={styles.offlineContent} data-palette="DesktopView">
          <div className="flex-set align-items-center me-3">
            <OfflineIcon />
            <a
              data-testid="disconnected-link"
              className={styles.statusLink}
              href={PLATFORM_STATUS_URL}
              target="_blank"
              rel="noreferrer noopener"
            >
              {t('common:disconnected')}
              <LearnMoreIcon className={styles.learnMoreIcon} />
            </a>
          </div>
          <div className={styles.lastUpdatedText}>
            {t('common:lastUpdated')} {t('common:updatedTime', { lastUpdated })}
          </div>
        </div>
      )}
      {isloggedin && isLiveChatEnabled && (
        <button
          data-testid="D5Ef8nGevvhsTtbJwDEY6"
          type="button"
          className={styles.liveChat}
          onClick={handleLiveChatClick}
          data-palette="DesktopView">
          <LiveChatIcon /> Live Chat
        </button>
      )}
    </div>)
  );
};

DesktopView.propTypes = {
  isOffline: PropTypes.bool,
  isOnline: PropTypes.bool,
  isloggedin: PropTypes.bool,
  disconnectTime: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
};

export default memo(DesktopView);
